import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Shield, Lock, Eye, Server } from 'lucide-react';
export function Security() {
  const features = [{
    icon: Lock,
    title: 'Verschlüsselung',
    desc: 'End-to-End verschlüsselte Kommunikation zwischen App, Cloud und Fahrzeug.'
  }, {
    icon: Eye,
    title: 'Privacy by Design',
    desc: 'Datenschutz ist tief in der Architektur verankert. Keine unnötige Datensammlung.'
  }, {
    icon: Server,
    title: 'DSGVO-Konform',
    desc: 'Datenverarbeitung nach strengen europäischen Datenschutzrichtlinien.'
  }, {
    icon: Shield,
    title: 'OEM-Standards',
    desc: 'Entwickelt nach den Sicherheitsvorgaben führender Automobilhersteller.'
  }];
  return <section className="py-24 bg-[#0f0f16] relative overflow-hidden" data-id="element-199">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-cyan-900/10 rounded-full blur-[100px]" data-id="element-200" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-201">
        <SectionHeading title="Sicherheit auf OEM-Niveau" subtitle="Ihre Sicherheit hat oberste Priorität. Unsere Technologie schützt Fahrzeug und Daten gleichermaßen." align="center" data-id="element-202" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12" data-id="element-203">
          {features.map((feature, index) => <div key={index} className="text-center group" data-id="element-204">
              <div className="w-16 h-16 mx-auto bg-gray-800 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-cyan-500/20 group-hover:scale-110 transition-all duration-300" data-id="element-205">
                <feature.icon className="w-8 h-8 text-gray-400 group-hover:text-cyan-400 transition-colors" data-id="element-206" />
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-207">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed" data-id="element-208">
                {feature.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}